"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPassword = void 0;
var react_1 = __importStar(require("react"));
var CheckCircleOutlined_1 = __importDefault(require("@mui/icons-material/CheckCircleOutlined"));
var PasswordTextField_1 = require("../PasswordTextField");
var PasswordRequirements_1 = require("../PasswordRequirements");
/**
 * Component that renders a change password form with a new password and confirm password inputs.
 * It includes callbacks so you can respond to changes in the inputs.
 *
 * @param onPasswordChange called when the new password or confirm new password fields value changes
 * @param initialNewPasswordValue initial value for the new password field
 * @param initialConfirmPasswordValue initial value for the confirm password field
 * @param passwordRequirements requirements to set password
 * @param newPasswordLabel label for the new password field (default = 'Password')
 * @param confirmPasswordLabel label for the confirm password field (default = 'Confirm')
 * @param passwordRef ref to forward to the password input.
 * @param confirmRef ref to forward to the confirm password input.
 * @param passwordNotMatchError text for showing message when passwords do not match.
 * @param onSubmit function to call when the form is submitted
 * @param passwordTextFieldProps props to pass to the password field.
 * @param confirmPasswordTextFieldProps props to pass to the confirm password field.
 *
 * @category Component
 */
var SetPassword = function (props) {
    var newPasswordLabel = props.newPasswordLabel, _a = props.initialNewPasswordValue, initialNewPasswordValue = _a === void 0 ? '' : _a, confirmPasswordLabel = props.confirmPasswordLabel, _b = props.initialConfirmPasswordValue, initialConfirmPasswordValue = _b === void 0 ? '' : _b, passwordRequirements = props.passwordRequirements, onPasswordChange = props.onPasswordChange, children = props.children, passwordRef = props.passwordRef, confirmRef = props.confirmRef, passwordNotMatchError = props.passwordNotMatchError, onSubmit = props.onSubmit, passwordTextFieldProps = props.passwordTextFieldProps, confirmPasswordTextFieldProps = props.confirmPasswordTextFieldProps;
    // Local State
    var _c = (0, react_1.useState)(initialNewPasswordValue), passwordInput = _c[0], setPasswordInput = _c[1];
    var _d = (0, react_1.useState)(initialConfirmPasswordValue), confirmInput = _d[0], setConfirmInput = _d[1];
    var _e = (0, react_1.useState)(initialConfirmPasswordValue ? true : false), shouldValidateConfirmPassword = _e[0], setShouldValidateConfirmPassword = _e[1];
    var _f = (0, react_1.useState)(initialNewPasswordValue ? true : false), shouldValidatePassword = _f[0], setShouldValidatePassword = _f[1];
    var onPassChange = (0, react_1.useCallback)(function (newPassword) {
        setPasswordInput(newPassword);
        onPasswordChange === null || onPasswordChange === void 0 ? void 0 : onPasswordChange({ password: newPassword, confirm: confirmInput });
    }, [setPasswordInput, onPasswordChange, confirmInput]);
    var onConfirmChange = (0, react_1.useCallback)(function (newConfirm) {
        setConfirmInput(newConfirm);
        onPasswordChange === null || onPasswordChange === void 0 ? void 0 : onPasswordChange({ password: passwordInput, confirm: newConfirm });
    }, [setConfirmInput, onPasswordChange, passwordInput]);
    var hasConfirmPasswordError = (0, react_1.useCallback)(function () { return shouldValidateConfirmPassword && confirmInput.length !== 0 && confirmInput !== passwordInput; }, [shouldValidateConfirmPassword, confirmInput, passwordInput]);
    var isValidPassword = (0, react_1.useCallback)(function () {
        if (passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.length)
            for (var i = 0; i < passwordRequirements.length; i++) {
                if (!new RegExp(passwordRequirements[i].regex).test(passwordInput))
                    return false;
            }
        return true;
    }, [passwordRequirements, passwordInput]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(PasswordTextField_1.PasswordTextField, __assign({ id: "password", "data-testid": "password", name: "password", inputRef: passwordRef, label: newPasswordLabel, value: passwordInput, error: shouldValidatePassword && !isValidPassword(), sx: {
                mt: { md: 4, sm: 3 },
            } }, passwordTextFieldProps, { onChange: function (evt) {
                // eslint-disable-next-line no-unused-expressions
                (passwordTextFieldProps === null || passwordTextFieldProps === void 0 ? void 0 : passwordTextFieldProps.onChange) && passwordTextFieldProps.onChange(evt);
                onPassChange(evt.target.value);
            }, onKeyUp: function (e) {
                if (e.key === 'Enter' && (confirmRef === null || confirmRef === void 0 ? void 0 : confirmRef.current)) {
                    confirmRef.current.focus();
                }
            }, onBlur: function (e) {
                // eslint-disable-next-line no-unused-expressions
                (passwordTextFieldProps === null || passwordTextFieldProps === void 0 ? void 0 : passwordTextFieldProps.onBlur) && passwordTextFieldProps.onBlur(e);
                setShouldValidatePassword(true);
            } })),
        passwordRequirements && passwordRequirements.length > 0 && (react_1.default.createElement(PasswordRequirements_1.PasswordRequirements, { sx: { mt: { xs: 2 }, mb: { xs: 2 } }, passwordText: passwordInput, passwordRequirements: passwordRequirements })),
        react_1.default.createElement(PasswordTextField_1.PasswordTextField, __assign({ id: "confirm", "data-testid": "confirm", name: "confirm", inputRef: confirmRef, label: confirmPasswordLabel, value: confirmInput, error: hasConfirmPasswordError(), helperText: hasConfirmPasswordError() ? passwordNotMatchError : '', icon: confirmInput.length !== 0 && isValidPassword() && confirmInput === passwordInput ? (react_1.default.createElement(CheckCircleOutlined_1.default, { "data-testid": "check", color: "success" })) : undefined }, confirmPasswordTextFieldProps, { onChange: function (evt) {
                // eslint-disable-next-line no-unused-expressions
                (confirmPasswordTextFieldProps === null || confirmPasswordTextFieldProps === void 0 ? void 0 : confirmPasswordTextFieldProps.onChange) && confirmPasswordTextFieldProps.onChange(evt);
                onConfirmChange(evt.target.value);
            }, onKeyUp: function (e) {
                if (e.key === 'Enter' && onSubmit)
                    onSubmit();
            }, onBlur: function (e) {
                // eslint-disable-next-line no-unused-expressions
                (confirmPasswordTextFieldProps === null || confirmPasswordTextFieldProps === void 0 ? void 0 : confirmPasswordTextFieldProps.onBlur) && confirmPasswordTextFieldProps.onBlur(e);
                setShouldValidateConfirmPassword(true);
            } }))));
};
exports.SetPassword = SetPassword;
